export const REQUESTS_STRUCTURED_SEARCH_ANCHOR_ID = "requests-structured-search-anchor";
